// frontend/src/components/auth/VerificationPending.jsx
import React, { useState, useEffect } from "react";

const RESEND_COOLDOWN_SECONDS = 60;

function VerificationPending({ email, onResend, onChangeEmail }) {
  const [status, setStatus] = useState("idle");
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setInterval(() => {
      setCountdown((c) => c - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const handleResend = async () => {
    if (countdown > 0 || status === "sending") return;
    setStatus("sending");
    const result = await onResend();
    if (result && result.success) {
      setStatus("resent");
      setCountdown(RESEND_COOLDOWN_SECONDS);
      setTimeout(() => setStatus("idle"), 4000);
    } else {
      setStatus("error");
    }
  };

  return (
    <div
      className="max-w-md mx-auto p-6 text-center"
      style={{
        color: "var(--text-primary, #333333)",
        background: "var(--bg-secondary, #f5f5f5)",
        borderRadius: "16px",
        boxShadow: "0 2px 16px rgba(0, 0, 0, 0.08)",
      }}
    >
      <div
        className="mx-auto mb-4 flex items-center justify-center"
        style={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          background: "rgba(46, 125, 50, 0.12)",
          fontSize: "32px",
        }}
      >
        📧
      </div>
      <h2 style={{ margin: "0 0 8px", fontSize: "1.5rem", fontWeight: 700 }}>
        Verify your email
      </h2>
      <p style={{ margin: "0 0 16px", color: "var(--text-secondary, #666666)", lineHeight: 1.5 }}>
        We sent a verification link to{" "}
        <strong style={{ color: "var(--text-primary, #333333)" }}>{email}</strong>.
        Click the link in that email to finish creating your account.
      </p>

      <div
        className="text-sm mb-6"
        style={{
          padding: "12px 16px",
          borderRadius: "8px",
          background: "var(--bg-tertiary, #e0e0e0)",
          color: "var(--text-secondary, #666666)",
        }}
      >
        Didn’t receive it? Check your spam or junk folder, or request a new link below.
      </div>

      <button
        type="button"
        onClick={handleResend}
        disabled={countdown > 0 || status === "sending"}
        style={{
          width: "100%",
          padding: "12px",
          borderRadius: "8px",
          border: "none",
          cursor: countdown > 0 || status === "sending" ? "not-allowed" : "pointer",
          fontWeight: 600,
          background:
            countdown > 0 || status === "sending"
              ? "var(--pista-button-disabled, #BDBDBD)"
              : "var(--pista-button-bg, #2E7D32)",
          color: "var(--pista-button-text, #FFFFFF)",
        }}
      >
        {status === "sending"
          ? "Sending..."
          : countdown > 0
          ? `Resend available in ${countdown}s`
          : status === "resent"
          ? "Email resent!"
          : "Resend verification email"}
      </button>

      {status === "error" && (
        <p className="text-sm mt-3" style={{ color: "#d32f2f" }}>
          Something went wrong. Please try again.
        </p>
      )}

      <button
        type="button"
        onClick={onChangeEmail}
        className="text-sm mt-4 underline"
        style={{
          background: "transparent",
          border: "none",
          color: "var(--text-secondary, #666666)",
          cursor: "pointer",
        }}
      >
        Use a different email address
      </button>
    </div>
  );
}

export default VerificationPending;
